import React, { ComponentProps } from "react";

export default function TimeCircleIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.5C3.86 15.5 0.5 12.1475 0.5 8C0.5 3.86 3.86 0.5 8 0.5C12.1475 0.5 15.5 3.86 15.5 8C15.5 12.1475 12.1475 15.5 8 15.5ZM10.3925 10.7825C10.4825 10.835 10.58 10.865 10.685 10.865C10.8725 10.865 11.06 10.7675 11.165 10.5875C11.3225 10.325 11.24 9.98 10.97 9.815L8.3 8.225V4.76C8.3 4.445 8.045 4.1975 7.7375 4.1975C7.43 4.1975 7.175 4.445 7.175 4.76V8.5475C7.175 8.7425 7.28 8.9225 7.4525 9.0275L10.3925 10.7825Z"
        fill={props.fill || "#6C53E8"}
      />
    </svg>
  );
}
